import { render, staticRenderFns } from "./DragAndDropTab.vue?vue&type=template&id=48f86ba6&scoped=true"
import script from "./DragAndDropTab.vue?vue&type=script&lang=js"
export * from "./DragAndDropTab.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropTab.vue?vue&type=style&index=0&id=48f86ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f86ba6",
  null
  
)

export default component.exports